export default function Hero() {
  return (
    <section className="mx-auto max-w-3xl px-6 pt-24 pb-16 text-center sm:pt-28 sm:pb-28">
      <h1 className="text-xl text-foreground/80 sm:text-2xl">
        The platform for building&nbsp;on&nbsp;AI.
      </h1>
      <p className="mt-8 mb-10 font-title text-5xl leading-[1.1] font-medium tracking-tight sm:mt-10 sm:mb-12 sm:text-6xl md:text-7xl">
        Tame the AI circus.
      </p>
      <div className="mt-10 text-lg text-muted-foreground sm:mt-12">
        <p>
          Author prompts
          <span className="px-2 text-xl text-spark-orange">•</span>
          Build workflows
          <br className="sm:hidden" />
          <span className="hidden px-2 text-xl text-spark-orange sm:inline">
            •
          </span>
          Evaluate quality
          <span className="px-2 text-xl text-spark-orange">•</span>
          Run at scale
        </p>
        <p className="mt-2 text-foreground/80">One platform.</p>
      </div>
    </section>
  )
}
